import React from 'react'

export class MoreReiviewsBtnComponent extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      showed: false
    }
    this.showMore = this.showMore.bind(this)
  }

  showMore(e) {
    e.preventDefault()
    let items = document.getElementsByClassName('review-item')
    for(let i = 0; i < items.length; i++) {
      let it = items[i]
      it.className = it.className
        .replace( /(?:^|\s)hidden(?!\S)/ , '' )
    }
    this.setState({
      showed: true
    })
  }

  render() {
    if(this.state.showed)
      return null
    return (
      <button className="btn btn--red" onClick={this.showMore}>
        Еще отзывы
      </button>
    )

  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/shared/reviews/more_reviews_btn.component.jsx